/** Zod validation schemas for Preferences endpoints */

import { z } from 'zod'
import { COMPILE_MODES } from '../types/wiki-template'

export const updatePreferenceSchema = z.object({
  value: z.string().max(10000),
})

/** Value of the `compile_mode` preference: compile in the user's own agent (free) or on AgentWiki (credits) */
export const compileModePreferenceSchema = z.enum(COMPILE_MODES)
